import React from 'react';

import { ReactComponent as IZLogo } from '@assets/images/header/iz-logo.svg';

import { ReactComponent as Facebook } from '@assets/images/social/fb.svg';
import { ReactComponent as Twitter } from '@assets/images/social/tw.svg';
import { ReactComponent as VK } from '@assets/images/social/vk.svg';
import { ReactComponent as OK } from '@assets/images/social/ok.svg';
import { ReactComponent as Telegram } from '@assets/images/social/telegram.svg';
import { ReactComponent as Youtube } from '@assets/images/social/youtube.svg';
import { ReactComponent as Instagram } from '@assets/images/social/instagram.svg';

export const PageFooter: React.FC = () => {
  return (
    <footer
      id="footer"
      className="
        bg-background-color-dark
        relative
        z-4
      "
    >
      <div
        className={`
          lg:w-full
          lg:max-w-1100
          mx-8
          lg:mx-auto
          py-12
          lg:py-15
        `}
      >
        <h2
          className="
            font-bold
            text-xl
            text-white
            mb-1.5
            lg:mb-4
          "
        >
          Над проектом работали:
        </h2>
        <p
          className="
            text-xs
            text-white
            mb-8
            lg:mb-14
          "
        >
          Валерий Воронов, Дарья Дементьева, Михаил Зинуланов, Дмитрий Ковальчук, Александр Колосков, Ирина Цырулева.
        </p>
        <div
          className="
            flex
            flex-col
            lg:flex-row
            justify-between
            items-start
          "
        >
          <div className="flex flex-col lg:flex-row items-start">
            <a className="flex flex-col mr-10 mb-2 lg:mb-0" href="https://iz.ru/">
              <IZLogo
                width={112}
                height={42}
                className="
                  pb-1.5
                  fill-current
                  text-white
                "
              />
            </a>
            <p className="text-xs font-normal leading-6 text-white max-w-xl mb-6 lg:mb-0">
              Зарегистрировано Федеральной службой по надзору в сфере связи, информационных технологий и массовых коммуникаций Свидетельство о регистрации ЭЛ № ФС 77 - 76208 от 8 июля 2019 года. Возрастные ограничения 18+
            </p>
          </div>

          <div
            className="
              flex
              flex-1
              flex-col
              items-start
              w-full
              lg:w-auto
              lg:ml-22
            "
          >
            <span
              className="
                text-xs
                text-white
                mb-2.5
              "
            >
              Мы в социальных сетях
            </span>
            <div
              className="
                flex
                justify-start
                lg:justify-between
                items-center
                w-full
              "
            >
              <a className="transition hover:opacity-50 mr-3 lg:mr-0" target="_blank" rel="noreferrer" href="http://facebook.com/izvestia.ru">
                <Facebook
                  width={10}
                  height={19}
                  className="
                    fill-current
                    text-white
                  "
                />
              </a>
              <a className="transition hover:opacity-50 mr-3 lg:mr-0" target="_blank" rel="noreferrer" href="https://vk.com/izvestia">
                <VK
                  width={25}
                  height={14}
                  className="
                    fill-current
                    text-white
                  "
                />
              </a>
              <a className="transition hover:opacity-50 mr-3 lg:mr-0" target="_blank" rel="noreferrer" href="https://twitter.com/izvestia_ru">
                <Twitter
                  width={20}
                  height={16}
                  className="
                    fill-current
                    text-white
                  "
                />
              </a>
              <a className="transition hover:opacity-50 mr-3 lg:mr-0" target="_blank" rel="noreferrer" href="https://twitter.com/izvestia_ru">
                <Youtube
                  width={59}
                  height={25}
                  className="
                    fill-current
                    text-white
                  "
                />
              </a>
              <a className="transition hover:opacity-50 mr-3 lg:mr-0" target="_blank" rel="noreferrer" href="https://t.me/izvestia">
                <Telegram
                  width={24}
                  height={22}
                  className="
                    fill-current
                    text-white
                  "
                />
              </a>
              <a className="transition hover:opacity-50 mr-3 lg:mr-0" target="_blank" rel="noreferrer" href="https://ok.ru/group/53243993063542">
                <OK
                  width={13}
                  height={22}
                  className="
                    fill-current
                    text-white
                  "
                />
              </a>
              <a className="transition hover:opacity-50 mr-3 lg:mr-0" target="_blank" rel="noreferrer" href="https://www.instagram.com/izvestia_ru/">
                <Instagram
                  width={23}
                  height={23}
                  className="
                    fill-current
                    text-white
                  "
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}